<script>
    import {Bar, mixins} from 'vue-chartjs';

    const {reactiveProp} = mixins;

    export default {
        name: "BarChart",
        extends: Bar,
        mixins: [reactiveProp],
        responsive: true,
        maintainAspectRatio: false,
        options: {
            legend: {
                display: this.displayLegend,
            },
        },
        beforeMount() {
            this.options = {
                responsive: true,
                maintainAspectRatio: false,
                beginAtZero: true,
                legend: {
                    display: this.displayLegend,
                },
                title: {
                    display: true,
                    text: this.titleChart
                },
                scales: {
                    xAxes: [{
                        stacked: true
                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            userCallback: function (label) {
                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            }
                        }
                    }]
                }
            };
        },
        props: {
            titleChart: String,
            displayLegend: Boolean,
        },
        mounted() {
            this.renderChart(this.chartData, this.options)
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/layout/BarChart.vue